import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { SurveysService, type QuestionNumericRule, type QuestionNumericRuleCreate, type QuestionNumericRuleUpdate } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";
import { fetchAll } from "./fetchAll";

export const useQuestionNumericRules = () =>
  useQuery({
    queryKey: ["question-numeric-rules"],
    queryFn: () => fetchAll<QuestionNumericRule>(SurveysService.getApiQuestionNumericRules),
    staleTime: 5 * 60_000,
  });

export const useCreateQuestionNumericRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: QuestionNumericRuleCreate) => {
      const res = await SurveysService.postApiQuestionNumericRules({ body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as QuestionNumericRule;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["question-numeric-rules"] }),
  });
};

export const useUpdateQuestionNumericRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: QuestionNumericRuleUpdate }) => {
      const res = await SurveysService.putApiQuestionNumericRulesById({ path: { id }, body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as QuestionNumericRule;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["question-numeric-rules"] }),
  });
};

export const useDeleteQuestionNumericRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await SurveysService.deleteApiQuestionNumericRulesById({ path: { id }, headers: getAuthHeaders() });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["question-numeric-rules"] }),
  });
};
